/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Output_LabelInputs */

const en_output_label = /** @type {(inputs: Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output`)
};

const ko_output_label = /** @type {(inputs: Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출력`)
};

const ja_output_label = /** @type {(inputs: Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力`)
};

/**
* | output |
* | --- |
* | "Output" |
*
* @param {Output_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const output_label = /** @type {((inputs?: Output_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Output_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_output_label(inputs)
	if (locale === "ko") return ko_output_label(inputs)
	return ja_output_label(inputs)
});